import { classNames } from 'shared/utils/Helper';
import styles from './style.module.scss';

import BrandLogo from '../brand_logo/BrandLogo';
import { useSelector } from 'react-redux';
const AuthWrapper = ({ children, mainImage, heading }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    return (
        <div className={classNames(styles.AuthWrapper, 'm-0 d-flex')}>
            <div className={classNames(styles.LeftRow)}>
                <BrandLogo brandStyle={classNames(styles.Brand)} />
                <div className={styles.ContentContainer}>
                    <img src={mainImage} alt="" className={styles.Image} />
                    <h5 className={styles.Heading}>{heading}</h5>
                </div>
            </div>
            <BrandLogo brandStyle={classNames(styles.MobileView)} />
            <div className={classNames(`${theme}ItemBackground`, styles.RightRow)}>{children}</div>
        </div>
    );
};

export default AuthWrapper;
